import { capitalize } from './utils';

export const replaceUnderscoreAndCapitalize = (str: string) => {
  return str
    .split('_')
    .map((word) => capitalize(word))
    .join(' ');
};
